var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
          _c("w-spacer"),
          _c("w-fa", {
            staticClass: "close-button",
            attrs: { icon: "times", right: "" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("from-product") },
                model: {
                  value: _vm.fromProduct,
                  callback: function ($$v) {
                    _vm.fromProduct = $$v
                  },
                  expression: "fromProduct",
                },
              }),
            ],
            1
          ),
          _c("w-row", { staticClass: "mt", attrs: { "no-margin": "" } }, [
            _c(
              "div",
              { staticClass: "w100" },
              [
                _c("div", { staticClass: "ledger-label" }, [
                  _vm._v(_vm._s(_vm.$ct("custom-account-title"))),
                ]),
                _c("app-ledger-account-autocomplete", {
                  staticClass: "w100",
                  attrs: {
                    fancy: "",
                    disabled: _vm.fromProduct,
                    label: _vm.$ct("ledger-account"),
                  },
                  model: {
                    value: _vm.ledgerAccountCode,
                    callback: function ($$v) {
                      _vm.ledgerAccountCode = $$v
                    },
                    expression: "ledgerAccountCode",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                icon: "check",
                disabled: !_vm.isValid || _vm.isSubmitting,
              },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }